<template>
  <div class="distributor-info">
    <router-link :to="{name:'distributorManager'}" class="back-to-list">
      <el-button icon="arrow-left">返回分销商列表</el-button>
    </router-link>
    <div class="edit-info">
      <p class="title">{{(check ? '分销商信息' : (!infoId ? '添加' : '编辑') + '分销商')}}</p>
      <el-form :model="infoForm" :rules="infoRules" ref="infoForm" label-width="93px" label-position="right"
               class="items">
        <el-form-item :prop="key" class="item" :label="item.txt" v-for="(item,key) in keyTxt" :key="key">
          <el-select :name="key" v-if="key==='brokerageRatio'" v-model="infoForm[key]" :placeholder="item.placeholder"
                     :disabled="!!check">
            <el-option :key="percent" v-for="percent in percentData" :label="percent" :value="percent"></el-option>
          </el-select>
          <el-select :name="key" v-if="key==='appRatio'" v-model="infoForm[key]" :placeholder="item.placeholder"
                     :disabled="!!check" @change="turnSwitch">
            <el-option :key="percent" v-for="percent in percentData2" :label="percent" :value="percent"></el-option>
          </el-select>
          <el-input :placeholder="item.placeholder" :name="key" v-if="key!='appRatio'&&key!='brokerageRatio'" size="small" v-model="infoForm[key]"
                    :disabled="!!check || !!infoId && (key==='idCardNo' || key==='mobile')">

          </el-input>
          <p class="idNumber-sign" v-if="key==='idCardNo' && !check">*仅添加是可以编辑，后续只读，不可修改</p>
          <p class="percent-sign" v-if="key==='brokerageRatio' && !check">
            指该分销商带来的的销售额中，需要按照该设置项来结算给该分销商的金额。该比例不能超过您与喜马拉雅的分成比例。</p>
          <p class="percent-sign" v-if="key==='appRatio' && !check">
            分成比例设置为0时，分销商不会看到绑定用户和APP内订单信息；分成比例不为0，分销商将直接获得收益并看到其带来的绑定用户和APP内订单信息。</p>  
        </el-form-item>
        <div class="handle-footer" v-if="!check">
          <el-button class="submit" type="primary" :loading="loading" @click="handleSubmit">确定</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </div>
      </el-form>
    </div>
    <div class="amendment-record" v-if="infoId">
      <p class="title">分成比例修改记录</p>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="modifiedAt"
          label="修改时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="newBrokerageRatio"
          label="分成比例"
          width="180">
        </el-table-column>
        <el-table-column
          prop="modifierName"
          label="修改人">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import {promotorInfo, promotorCreate, promotorUpdate} from 'api'
  import {validatePhone, validateidCardNo} from 'utils/validate';

  export default {
    data() {
      const validateFun = (valueRole, errorText = '不能为空') =>
        ((rule, value, callback) => {
          if (rule.required === true && (!value || (typeof valueRole === "function" && !valueRole(value)))) {
            callback(new Error(errorText));
          } else {
            callback();
          }
        })
      const createRole = (obj) => {
        return Object.assign({}, {
          required: true, validator: validateFun()
        }, obj)
      }

      const percentData = []
      for (let i = 0; i < 36; i++) {
        percentData.push(`${i}%`)
      }
      const percentData2 = []
      for (let i = 0; i < 11; i++) {
        percentData2.push(`${i}%`)
      }


      return {
        tableData: [],
        loading: false,
        check: false,
        infoId: 0,
        keyTxt: {
          name: {
            txt: '姓名',
            placeholder: '请输入姓名'
          },
          mobile: {
            txt: '手机号',
            placeholder: '请输入手机号'
          },
          idCardNo: {
            txt: '身份证号',
            placeholder: '请输入身份证号'
          },
          brokerageRatio: {
            txt: '站外订单分成比例',
            placeholder: '请选择分成比例'
          },
          appRatio: {
            txt: 'APP站内订单分成比例',
            placeholder: '请选择分成比例'
          }
        },
        infoForm: {
          name: '',
          mobile: '',
          idCardNo: "",
          brokerageRatio: "",
          appRatio: "",
          needDisPlayPrivilege: 0
        },
        percentData: percentData,
        percentData2: percentData2,
        infoRules: {
          mobile: [
            // createRole({validator: validateFun(validatePhone, '请输入正确的手机号码')})
          ],
          name: [createRole()],
          idCardNo: [
            // createRole({validator: validateFun(validateidCardNo, '请输入正确的身份证号')})
          ]
        },
      }
    },
    props: [],
    components: {},
    computed: {},
    mounted() {
      let params = this.$route.params;
      console.log(params);
      this.check = !!(+params.check);
      this.infoId = +params.infoId;
      this.infoId && this.dataInit(this.infoId)
    },
    methods: {
      turnSwitch(val) {
        if(val == 0 || val == '0%') {
          this.$data.infoForm.needDisPlayPrivilege = 0
        } else {
          this.$data.infoForm.needDisPlayPrivilege = 1
        }
      },
      handleSubmit() {
        let vis = this;
        vis.$refs.infoForm.validate((valid) => {
          if (valid) {
            vis.loading = true;
            if (this.infoId) {
              promotorUpdate(Object.assign({id: this.infoId}, this.infoForm)).then((res) => {
                vis.loading = false;
                if (parseInt(res.ret) === 0) {
                  this.$message({
                    type: 'success',
                    message: '修改成功!'
                  });
                  vis.$router.push({name: 'distributorManager'})
                }
              }).catch(() => {
                vis.loading = false
              })
            } else {
              promotorCreate(this.infoForm).then((res) => {
                vis.loading = false;
                if (parseInt(res.ret) === 0) {
                  this.$message({
                    type: 'success',
                    message: '创建成功!'
                  });
                  vis.$router.push({name: 'distributorManager'})
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  });
                }
              }).catch(() => {
                vis.loading = false
              })
            }
          } else {
            //console.log('error submit')
            return false
          }
        })

      },
      handleCancel() {
        let vis = this;
        if (vis.infoId) {
          vis.dataInit(vis.infoId)
        } else {
          vis.$refs['infoForm'].resetFields();
        }
      },
      dataInit(promotorId) {
        let vis = this;
        promotorInfo(promotorId).then(res => {
          const resData = res.data;
          vis.infoForm = resData.promotor;
          vis.tableData = resData.ratios;
        }).catch(() => {
        })
      }
    },
    watch: {}
  }
</script>

<style lang="scss" scoped>
  .title {
    width: 695px;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    box-shadow: inset 0 -1px 0 0 #E8E8E8;
  }

  .back-to-list {
    margin-bottom: 10px;
    display: inline-block;
  }

  .edit-info {
    background-color: #fff;
    width: 745px;
    padding: 20px 20px 0px 20px;
    .el-form-item {
      padding-bottom: 22px;
      margin-bottom: 0;
      &:first-child {
        margin-top: 20px;
      }
    }
    .auth-sign {
      max-width: 360px;
      padding: 0px;
      margin: 0px;
      line-height: 18px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #48576a;
    }
    .item {
      .el-input, .el-select {
        width: 360px;
      }
      .idNumber-sign, .percent-sign {
        max-width: 360px;
        padding: 0px;
        margin: 0px;
        line-height: 18px;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #999999;
      }
    }
    .handle-footer {
      margin-left: -20px;
      width: 745px;
      padding: 13px 0px 13px 20px;
      box-shadow: inset 0 1px 0 0 #E8E8E8;
    }
  }

  .amendment-record {
    margin-top: 10px;
    width: 745px;
    padding: 20px 20px 40px 20px;
    background: #fff;
    .title {
      width: 705px;
    }
    .el-table {
      td {
        border-bottom: none;
      }
    }
  }

  .oTip{
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    padding: 8px;
    font-size: 14px;
    color: #333;
    width: 333px;
    color: #fff;
    background-color: #1f2d3d;
    border-radius: 5px;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// distributorInfo.vue?7065b8be